import React from 'react'

export default function PrimaryHeading ({ children, border = false, className = '' }) {
  const classNames = [
    'page-title text-3xl font-medium w-full',
    className,
    border ? 'border-b pb-2 mb-6' : ''
  ]

  return (
    <h1 className={classNames.join(' ')}>
      {children}
    </h1>
  )
}
